var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "flex-box"
  }, [_c('a-checkbox', {
    staticStyle: {
      "width": "20px"
    },
    on: {
      "change": _vm.handerConfirmationHetterChange
    }
  }), _c('p', {
    staticClass: "text-content flex-item"
  }, [_vm._v(_vm._s(_vm.content))])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };